import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionAreasComponent {
  constructor($filter, FanProyectoConfiguracionAreasService) {
    this.orderBy = $filter('orderBy')
    this.FanProyectoConfiguracionAreasService = FanProyectoConfiguracionAreasService
    this.idProyecto = undefined
    this.actualizando = null
    this.agregando = false
    this.eliminando = null
    this.filtro = ''
  }

  $onInit() {
    this.promise = this.FanProyectoConfiguracionAreasService.get(this.idProyecto)
      .then((response) => (this.data = this.orderBy(response.data, 'descripcion')))
  }

  actualizar(item, data) {
    if (data) {
      angular.extend(item, data)
      this.data = [].concat(this.data)
    }

    this.actualizando = null
  }

  agregar(data) {
    if (data) {
      this.data.push(data)
      this.data = this.orderBy(this.data, 'descripcion')
    }

    this.agregando = null
  }

  eliminar(item) {
    if (item) {
      this.data.splice(this.data.indexOf(item), 1)
      this.data = [].concat(this.data)
    }

    this.eliminando = null
  }
}

module.component('fanProyectoConfigAreas', {
  controller: FanProyectoConfiguracionAreasComponent,
  template: template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/areas/component.js